import { useCallback, useSyncExternalStore } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

function subscribeTo(query: string) {
  return (callback: () => void) => {
    if (typeof window === 'undefined') return () => {};
    const mql = window.matchMedia(query);
    // Older Safari/WebKit only has addListener/removeListener on MediaQueryList.
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', callback);
      return () => mql.removeEventListener('change', callback);
    }
    mql.addListener(callback);
    return () => mql.removeListener(callback);
  };
}

function getServerSnapshot() {
  return false;
}

/**
 * Whether a CSS media query currently matches, kept in sync as it changes.
 *
 * For layout that CSS can express, prefer Tailwind's responsive prefixes —
 * this is for the cases where a JS value is genuinely needed (a prop like
 * `numberOfMonths`, say, which has no CSS equivalent).
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(subscribeTo(query), [query]);
  const getSnapshot = useCallback(
    () => window.matchMedia(query).matches,
    [query]
  );
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/**
 * Returns true when the viewport is below Tailwind's `md` breakpoint (768px).
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
